import { parseCartAttributes } from "@novel/shared/utils/parseCartAttributes";
import { getFromCookies, parseCookiesToObj, removeCookie, setCookie, } from "@novel/shared/utils/cookieUtils";
import uniq from "lodash/uniq";
import qs from "qs";
import { addDiscountToCheckout } from "@novel/shared/utils/createShopifyPermalink";
export async function getCartHosted() {
    return await fetch("/cart.js", {
        method: "GET",
        mode: "cors",
    })
        .then((res) => res.json())
        .then((res) => ({
        isHeadless: false,
        cartToken: res.token,
        customAttributes: parseCartAttributes(res.attributes),
        discountApplications: uniq((res.cart_level_discount_applications || [])
            .concat(parseCookiesToObj(document.cookie).discount_code)
            .map((discountApplication) => ((discountApplication === null || discountApplication === void 0 ? void 0 : discountApplication.title) || (discountApplication === null || discountApplication === void 0 ? void 0 : discountApplication.code) || "").trim())
            .filter(Boolean)),
    }));
}
// this operation on hosted Shopify works as a one-layer-deep upsert
// slightly different from "setCustomerAttributesHeadless" which overwrites all custom attributes
export async function upsertCartAttributesHosted(attributes) {
    var _a, _b;
    const rootPath = (typeof window !== "undefined" && ((_b = (_a = window.Shopify) === null || _a === void 0 ? void 0 : _a.routes) === null || _b === void 0 ? void 0 : _b.root)) || "/";
    const res = await fetch(`${rootPath}cart/update.js${qs.stringify({ attributes }, { addQueryPrefix: true })}`, {
        method: "POST",
        mode: "cors",
    }).then((res) => res.json());
    return {
        isHeadless: false,
        cartToken: res.token,
        customAttributes: parseCartAttributes(res.attributes),
        discountApplications: (res.cart_level_discount_applications || [])
            .map((discountApplication) => (discountApplication === null || discountApplication === void 0 ? void 0 : discountApplication.title) || (discountApplication === null || discountApplication === void 0 ? void 0 : discountApplication.code))
            .filter(Boolean),
    };
}
// applies the discount code but note that it does not show up until the customer goes to checkout
// (there is also no way to check that the discount code has been applied via API calls, it doesn't come back in "discountApplications")
export async function applyCartDiscountCodeOrGiftCardHosted(discountCode) {
    // setting this cookie is a almost-always-unnecessary backup,
    // so we only do it if no other discount code cookie has been set
    const existingDiscountCode = getFromCookies("discount_code");
    if (!existingDiscountCode) {
        setCookie({
            name: "discount_code",
            value: discountCode,
        });
    }
    await upsertCartAttributesHosted({
        // is passed to Shopify Plus scripts for apply
        "sf-code": discountCode,
    });
    await addDiscountToCheckout({
        shopifyHostedDomain: window.location.host,
        discount: discountCode,
    }).catch((e) => {
        console.error("Failed to apply discount code:", e);
    });
}
export async function removeDiscountCodeHosted() {
    // only way I found to remove discount code on hosted site was to apply a discount code
    // that does not exist to checkout generated 255 code which is unlikely to exist as
    // a discount on any shop
    const nonExistentDiscountCode = `L-ewXtTIpjMs1l856xFut4epjShi9bWT1ZgO7eVRwEAbFy4nE-cD_uoOZ4vkf-herab11MsrQ62yJdmCpBbXxPssjFSH-awy0FxZk71zTDMR6KOU7dXNa3iGr1SXHPLtdpXSfcSWIhMhXTsDfBRk2QmApD8NNWC3C-WhRLKoWNwFw9Y7CctuQzQnSoxVHC-YJPhXxiC4nQrEYbSZ3WU6NDSttSCqr8tmpIY3lXq07jgsU0hyefMGQf-gv91qJAk`;
    await fetch(`https://${window.location.host}/discount/${nonExistentDiscountCode}`);
    // expire all discount code cookies
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        if (name.trim() === "discount_code") {
            removeCookie(name);
            break;
        }
    }
    return await getCartHosted();
}
